module.exports = __webpack_public_path__ + "img/sports-score.b6ce6c75.svg";